// EVENTS.VIEWS.USER.RESET_PASSWORD

export const RESET_PASSWORD = {
  PAGE_VISITED: 'reset_password-page_visited'
};
